import React, { useState, FormEvent } from 'react';
import './Login.scss';
import { BaseReact } from '../../base.model';
import { Link } from 'react-router-dom';
import { LogoBanner } from '../visuals/banner.logo';
import InputAnimated from './input/input';
import RecoverPassword from './LostPassword';

const LOGIN_URL = `${new URL(process.env.REACT_APP_HTTP_URL!).origin}/mainuserlogin`;

interface LoginProps extends BaseReact {}

function Login({ history, location }: LoginProps) {
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('');

    const [loginError, setLoginError] = useState('');

    const [registering, setRegistering] = useState(false);


    const submitLogin = async (e: FormEvent) => {
        e.preventDefault();
        if (!email || !password) {
            return;
        }
        setRegistering(true);
        setLoginError('');
        try {
            // Back-end sets fp_mws_profileid on success; we just need to follow its redirect.
            const response = await fetch(LOGIN_URL, {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            if (!response.ok) {
                const errText = await response.text();
                setRegistering(false);
                setLoginError(errText || 'Contraseña o usuario equivocados');
                return;
            }
            const { redirect } = await response.json() as { redirect?: string };
            if (!redirect) {
                setRegistering(false);
                setLoginError('No se recibió URL de redirección del servidor');
                return;
            }
            // Full navigation so bootstrap + CurrentUserProvider see the new cookie and refetch `me`.
            window.location.replace(redirect);
        } catch (err) {
            setRegistering(false);
            console.error('Error logging in: ', err);
            setLoginError(err instanceof Error ? err.message : 'Error al iniciar sesión');
        }
    }

    const _setEmail = (e: string) => {
        setEmail(e.toLowerCase().trim());
    }

    return (
        <div id="Login">
            <div className="_loginContainer">
                <LogoBanner />

                <div className="_logoSelect">
                    <div className="_withReturn">
                        <a href="https://fiscalpop.com/login?type=ecommerce">
                            <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none">
                                <path d="M26 13.5H1" stroke="#AFAFAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M13.5 26L1 13.5L13.5 1" stroke="#AFAFAF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </a>
                        <div> <h2 className="gray">eCommerce </h2><h3>Amazon </h3></div>
                    </div>
                    <form onSubmit={submitLogin}>
                        <InputAnimated
                            type="text"
                            value={email}
                            label="Email"
                            onChange={_setEmail}
                        />
                        <InputAnimated
                            type="password"
                            value={password}
                            label="Contraseña"
                            onChange={setPassword}
                        />
                        <Link to="/login?recover=true" >¿Olvidaste tu contraseña?</Link>
                        <div className="_actions">
                            {
                                (!!loginError ? <span className='error'>{loginError}</span> : <span></span>)
                            }
                            <button type="submit" disabled={!email || !password}>
                                {
                                    registering ? 'Entrando' :
                                        'Entrar'
                                }
                            </button>
                        </div>
                    </form>
                </div>
                <Link to="/register">
                    ¿No tienes cuenta? <b>Regístrate</b>
                </Link>
                <RecoverPassword history={history} location={location} />
            </div>
        </div>
    )
}

export default Login;